import React from 'react';
import TrueImpactLevelFeedbackModal from 'shared/design-system/components/TrueImpactLevelFeedbackModal';

interface GuessMeasurementReasonModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  initialReason: string;
  measurement: string;
  indicatorName: string;
}

const GuessMeasurementReasonModal: React.FC<GuessMeasurementReasonModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialReason,
  measurement,
  indicatorName,
}) => {
  return (
    <TrueImpactLevelFeedbackModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Save"
      initialNote={initialReason}
      placeholder="Please explain the basis for this guess..."
      message={
        <>
          The measurement for <strong>{indicatorName}</strong> is set to{' '}
          <strong>"{measurement}"</strong>, which is a <strong>Guess</strong>{' '}
          measurement type.
          <br />
          <br />
          Guess-level estimates are acceptable, however donors often find data
          from Direct Measurement or Evidence-based Estimates more compelling.
          For practical ideas, see:{' '}
          <a
            href="https://support.trueimpact.com/improving-data-quality-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Improving Data Quality
          </a>
          {' & '}
          <a
            href="https://support.trueimpact.com/true-impacts-top-5-data-collection-best-practices-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Top 5 Data Collection Best Practices
          </a>
          .
          <br />
          <br />
          Please provide a reason explaining the basis of your guess.
        </>
      }
    />
  );
};

export default GuessMeasurementReasonModal;
